export const formatMsaNameFromAlias = msaAlias =>
  msaAlias.replace(/\b[a-z]([a-z]$|)/g, x => x.toUpperCase()).replace(/-/g, ' ');
